import { RootState } from '../root.reducers';
import { DialedDigitExtractionServer } from './dialedDigitExtractionServer.types';

export const getDialedDigitExtractionServerList = (state: RootState): DialedDigitExtractionServer[] =>
  state.dialedDigitExtractionServer.entities;

export const getDialedDigitExtractionServer = (state: RootState): DialedDigitExtractionServer | null =>
  state.dialedDigitExtractionServer.single;

export const getSelectedDialedDigitExtractionServer = (state: RootState): DialedDigitExtractionServer[] =>
  state.dialedDigitExtractionServer.selected;

export const getDialedDigitExtractionServerCreatedId = (state: RootState): string | null =>
  state.dialedDigitExtractionServer.createdId;

export const isDialedDigitExtractionServerCreatePopupOpen = (state: RootState): boolean =>
  state.dialedDigitExtractionServer.ui.isCreatePopupOpen;

export const isDialedDigitExtractionServerLoading = (state: RootState): boolean =>
  state.dialedDigitExtractionServer.ui.isLoading;
